import { DETAIL_GET, DETAIL_RESET } from "./mutation-types";
import { errorMessage } from "@/services/MessageService";
import { firestore, database } from "@/config/firebase";
import moment from "moment";

export default {
  async getDetail({ commit }, id) {
    const arr = [];
    let dataOrder = {};
    try {
      await firestore(`damages`)
        .doc(id)
        .get()
        .then(querySnapshot => {
          if (!querySnapshot.empty) {
            dataOrder = {
              key: querySnapshot.id,
              id: querySnapshot.data().id,
              location: querySnapshot.data().location,
              userContact: querySnapshot.data().userContact,
              userPhone: querySnapshot.data().userPhone,
              saleOrderID: querySnapshot.data().saleOrderID
            };
            firestore(`damages/${id}/order`)
              .get()
              .then(order => {
                order.forEach(serie => {
                  arr.push({ key: serie.id, ...serie.data() });
                });
              });
            commit(DETAIL_GET, { arr, dataOrder, exist: true });
          } else if (querySnapshot.empty) {
            commit(DETAIL_GET, { arr, dataOrder, exist: false });
          }
        });
    } catch (error) {
      errorMessage("No se puedo obtener los detalles de la orden");
    }
  },
  async getSearchedOrder({ commit }, data) {
    const arr = [];
    const { orderNumber, orderType } = data;
    let dataOrder = {};
    if (orderNumber) {
      try {
        await firestore("damages")
          .where(orderType == "order" ? "id" : "saleOrderID", "==", orderNumber)
          .limit(1)
          .get()
          .then(querySnapshot => {
            if (!querySnapshot.empty) {
              dataOrder = {
                key: querySnapshot.docs[0].id,
                id: querySnapshot.docs[0].data().id,
                location: querySnapshot.docs[0].data().location,
                userContact: querySnapshot.docs[0].data().userContact,
                userPhone: querySnapshot.docs[0].data().userPhone,
                saleOrderID: querySnapshot.docs[0].data().saleOrderID
              };
              firestore(`damages/${querySnapshot.docs[0].id}/order`)
                .get()
                .then(order => {
                  order.forEach(serie => {
                    arr.push({ key: serie.id, ...serie.data() });
                  });
                });
              commit(DETAIL_GET, { arr, dataOrder, exist: true });
            } else if (querySnapshot.empty) {
              commit(DETAIL_GET, { arr, dataOrder, exist: false });
            }
          });
      } catch (error) {
        errorMessage("No se pudo obtener el número de orden buscada.");
      }
    }
  },
  async getHistoryOrders(_, data) {
    const orderData = [];
    const { orderNumber, orderType } = data;
    if (orderNumber && orderType) {
      try {
        const damageSnap = await firestore("damages")
          .where(orderType, "==", orderNumber)
          .get();
        for (const damage of damageSnap.docs) {
          if (damage.exists) {
            // :: Get analytics of checklist by orderID
            const checklistCompleted = await database("analytics")
              .child("global")
              .orderByChild("orderID")
              .equalTo(damage.id)
              .once("value");

            const orderSnap = await firestore(
              `damages/${damage.id}/order`
            ).get();
            for (const order of orderSnap.docs) {
              if (order.exists) {
                const checklist = getChecklistByStatus(
                  checklistCompleted.val(),
                  order.data().status,
                  order.id,
                  order.data().statusMap
                );
                orderData.push({
                  damageData: {
                    ...damage.data(),
                    docID: damage.id
                  },
                  orderData: {
                    ...order.data(),
                    docID: order.id
                  },
                  checklist
                });
              }
            }
          }
        }
        return orderData;
      } catch (error) {
        errorMessage("No se pudo obtener el número de orden buscada.");
      }
    }
  },
  async getHistorySerie(_, seriesNumber) {
    const seriesArr = [];
    if (seriesNumber) {
      try {
        const data = await database(`damageSeries/${seriesNumber}`).once(
          "value"
        );
        if (data.exists()) {
          const orderNumber = data.val();
          for (let i = 0; i < orderNumber.length; i++) {
            const damageID = orderNumber[i].toString();
            const damage = await firestore("damages")
              .doc(damageID)
              .get();
            if (damage.exists) {
              // :: Get analytics of checklist by orderID
              const checklistCompleted = await database("analytics")
                .child("global")
                .orderByChild("orderID")
                .equalTo(damageID)
                .once("value");

              // :: Get orders to Firestore
              const orderSnap = await firestore("damages")
                .doc(damageID)
                .collection("order")
                .get();
              for (const order of orderSnap.docs) {
                if (order.exists) {
                  const checklist = getChecklistByStatus(
                    checklistCompleted.val(),
                    order.data().status,
                    order.id,
                    order.data().statusMap
                  );
                  seriesArr.push({
                    damageData: {
                      ...damage.data(),
                      docID: damage.id
                    },
                    orderData: {
                      ...order.data(),
                      docID: order.id
                    },
                    checklist: checklist
                  });
                }
              }
            }
          }
          return seriesArr;
        } else {
          return null;
        }
      } catch (error) {
        errorMessage("No se pudo obtener el número de orden buscada.");
      }
    }
  },
  async getSearchedSerie(_, seriesNumber) {
    const seriesArr = [];
    if (seriesNumber) {
      try {
        const data = await database(`damageSeries/${seriesNumber}`).once(
          "value"
        );
        if (data.exists()) {
          const orderNumber = data.val();
          for (let i = 0; i < orderNumber.length; i++) {
            const orderID = orderNumber[i].toString();
            const orderData = await firestore("damages")
              .doc(orderID)
              .get();
            seriesArr.push(orderData.data());
          }
          return seriesArr;
        } else {
          return null;
        }
      } catch (error) {
        errorMessage("No se pudo obtener el número de orden buscada.");
      }
    }
  },
  async resetDetail({ commit }) {
    commit(DETAIL_RESET);
  }
};
function outputStatusData(name, event) {
  return {
    onlyLetter: "S",
    name,
    status: "Salida",
    completedChecklist: false,
    type: "input",
    event
  };
}
function inputStatusData(checklistData, name, event) {
  const responseData = [];
  if (checklistData.length != 0) {
    for (const checklistTemp of checklistData) {
      responseData.push({
        completed: checklistTemp.completed,
        incidence: checklistTemp.incidence,
        onlyLetter: "E",
        name,
        status: "Entrada",
        completedChecklist: true,
        type: "output",
        event
      });
    }
  } else {
    responseData.push({
      onlyLetter: "E",
      name,
      status: "Entrada",
      completedChecklist: true,
      type: "output",
      event
    });
  }
  return responseData;
}
function inputStatusCompletedData(
  checklistAnalytics,
  name,
  status,
  statusShort,
  statusName,
  orderID,
  event
) {
  const checklistData = checklistAnalytics.find(
    el => el.productID === orderID && el.statusType === status
  );
  const timestampID = moment().unix();
  if (checklistData) {
    return {
      completed: checklistData.completed,
      incidence: checklistData.incidence,
      timestampID,
      onlyLetter: statusShort,
      name,
      status: statusName,
      completedChecklist: true,
      type: status,
      event
    };
  } else {
    return {
      timestampID,
      onlyLetter: statusShort,
      name,
      status: statusName,
      completedChecklist: true,
      type: status,
      event
    };
  }
}

function getChecklistByStatus(checklistCompleted, status, orderID, statusMap) {
  const checklistAnalytics = checklistCompleted
    ? Object.values(checklistCompleted)
    : [];
  const checklistData = checklistAnalytics.filter(
    el => el.productID === orderID
  );

  const responseData = [];
  switch (status) {
    case "deliveryOutput":
      responseData.push(outputStatusData("Entrega", "delivery"));
      return responseData;
    case "maintenanceOutput":
      responseData.push(outputStatusData("Mantenimiento", "maintenance"));
      return responseData;
    case "relocationOutput":
      responseData.push(outputStatusData("Reubicación", "relocation"));
      return responseData;
    case "recollectionOutput":
      responseData.push(outputStatusData("Recolección", "recollection"));
      return responseData;
    case "rented-serviceOutput":
      responseData.push(outputStatusData("Rentado Servicio", "rented-service"));
      return responseData;
    // :: Input status filters
    case "deliveryInput":
      return inputStatusData(checklistData, "Entrega", "delivery");
    case "maintenanceInput":
      return inputStatusData(checklistData, "Mantenimiento", "maintenance");
    case "relocationInput":
      return inputStatusData(checklistData, "Reubicación", "relocation");
    case "recollectionInput":
      return inputStatusData(checklistData, "Recolección", "recollection");
    case "rented-serviceInput":
      return inputStatusData(
        checklistData,
        "Rentado Servicio",
        "rented-service"
      );
    case "completed":
      return getCehcklistCompletedByStatus(
        statusMap,
        checklistAnalytics,
        orderID
      );
  }
}

function getCehcklistCompletedByStatus(statusMap, checklistAnalytics, orderID) {
  for (const state in statusMap) {
    if (Object.hasOwnProperty.call(statusMap, state)) {
      const status = statusMap[state];
      if (status.input) {
        const tempData = [];
        switch (state) {
          case "delivery":
            tempData.push(
              inputStatusCompletedData(
                checklistAnalytics,
                "Entrega",
                "input",
                "S",
                "Salida",
                orderID,
                "delivery"
              )
            );
            tempData.push(
              inputStatusCompletedData(
                checklistAnalytics,
                "Entrega",
                "output",
                "E",
                "Entrada",
                orderID,
                "delivery"
              )
            );
            return tempData;
          case "maintenance":
            tempData.push(
              inputStatusCompletedData(
                checklistAnalytics,
                "Mantenimiento",
                "input",
                "S",
                "Salida",
                orderID,
                "maintenance"
              )
            );
            tempData.push(
              inputStatusCompletedData(
                checklistAnalytics,
                "Mantenimiento",
                "output",
                "E",
                "Entrada",
                orderID,
                "maintenance"
              )
            );
            return tempData;
          case "recollection":
            tempData.push(
              inputStatusCompletedData(
                checklistAnalytics,
                "Reubicación",
                "input",
                "S",
                "Salida",
                orderID,
                "recollection"
              )
            );
            tempData.push(
              inputStatusCompletedData(
                checklistAnalytics,
                "Reubicación",
                "output",
                "E",
                "Entrada",
                orderID,
                "recollection"
              )
            );
            return tempData;
          case "relocation":
            tempData.push(
              inputStatusCompletedData(
                checklistAnalytics,
                "Recolección",
                "input",
                "S",
                "Salida",
                orderID,
                "relocation"
              )
            );
            tempData.push(
              inputStatusCompletedData(
                checklistAnalytics,
                "Recolección",
                "output",
                "E",
                "Entrada",
                orderID,
                "relocation"
              )
            );
            return tempData;
          case "rentedService":
            tempData.push(
              inputStatusCompletedData(
                checklistAnalytics,
                "Rentado Servicio",
                "input",
                "S",
                "Salida",
                orderID,
                "rentedService"
              )
            );
            tempData.push(
              inputStatusCompletedData(
                checklistAnalytics,
                "Rentado Servicio",
                "output",
                "E",
                "Entrada",
                orderID,
                "rented-service"
              )
            );
            return tempData;
        }
      }
    }
  }
}
